export function formatMaxFileSizeExceededMessage(maxFileSizeBytes) {
  const mb = maxFileSizeBytes / (1024 * 1024)
  const label = Number.isInteger(mb) ? `${mb}MB` : `${mb.toFixed(1)}MB`

  return `File must be ${label} or smaller.`
}
